import axios from '@axios'

const PREFIX = '/indicacoes'

export default {

  getIndicacoes(page, pageSize, filtros) {
    return axios.post(`${PREFIX}?page=${page}&pageSize=${pageSize}`, filtros)
  },

  getIndicacao(id) {
    return axios.get(`${PREFIX}/${id}`)
  },

  updateIndicacao(id, indicacao) {
    return axios.put(`${PREFIX}/${id}`, indicacao)
  },

  createIndicacao(indicacao) {
    return axios.post(`${PREFIX}/add`, indicacao)
  },

  deleteIndicacao(id, inativar) {
    return axios.delete(`${PREFIX}/${id}?inativar=${inativar}`)
  },

  deleteAll(idList) {
    return axios.delete(`${PREFIX}/lote`, { data: idList })
  },

  validaEmail(id, email) {
    if (id) {
      return axios.get(`${PREFIX}/${id}/email/${email}`)
    }
    return axios.get(`${PREFIX}/email/${email}`)
  },

  getIndicacoesResumidas(filtro) {
    return axios.post(`${PREFIX}/resumido`, filtro)
  },

  verificaVinculo(id) {
    return axios.post(`${PREFIX}/vinculo?id=${id}`)
  },
}
